export default __webpack_public_path__ + "static/media/garahex-logo-white.0c912d71.png";